<template>
  <!-- 为啥会有这个组件，主要是货币、整数、小数部分字体大小不一样，在这里做拆分，然后也方便样式上的对齐 -->
  <div class="base-price-text" :style="{color: color}">
    <slot name="left"></slot><span
      class="currency"
      :style="`${styleOption.currency};font-weight: ${fontWeight};`"
    >¥</span><span
      class="price-integer"
      :style="`${styleOption.integer};font-weight: ${fontWeight};`"
    >{{priceInfo.integer}}</span><span
      v-if="priceInfo.decimal"
      class="price-decimal"
      :style="`${styleOption.decimal};font-weight: ${fontWeight};`"
    >{{priceInfo.decimal}}</span><slot name="right"></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    price: {
      type: Number,
    },
    color: {
      type: String,
      default: '#FF5900',
    },
    fontWeight: {
      type: String,
      default: '600',
    },
    styleOption: {
      type: Object,
      default() {
        return {
          currency: '',
          integer: '',
          decimal: '',
        };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    priceInfo() {
      if (this.price === undefined) return {};
      const dividePrice = this.price / 100;
      const item = {
        integer: '',
        decimal: '',
      };
      if (Number.isInteger(dividePrice)) {  
        item.integer = `${dividePrice}`;
        item.decimal = '';
      } else {
        // 小数
        const priceList = `${dividePrice}`.split('.');
        item.integer = priceList[0];
        item.decimal = `.${priceList[1]}`;
      }
      
      return item;
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.base-price-text{
  line-height: 1;
  font-family: Arial;
  .currency {
    font-size: 14px;
    vertical-align: bottom;
    font-weight: 600;
  }
  .price-integer {
    font-size: 16px;
    vertical-align: bottom;
    font-weight: 600;
  }
  .price-decimal {
    font-size: 12px;
    vertical-align: bottom;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/base/base-price-text.vue